import { Col, Image, Row } from "antd";
import React, { useEffect, useState } from "react";
import Logo from "../Assests/logo.svg";
import { OutlineButton, SimpleButton } from "../Components/common/Buttons";
import { useWindowWidth } from "@react-hook/window-size";
import {
  LogoutOutlined,
  PoweroffOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { SimpleParagraph } from "../Components/common/Paragraph";
import AntDrawer from "../Components/common/AntDrawer";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import style from "./index.module.less";
import MenuItem from "../Components/common/MenuItem";
import Sidebar from "../Components/common/Sidebar";
import LogoutModal from "../Components/LogoutModal/LogoutModal";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/Slices/AuthSlice";
import { toggleLoading } from "../Redux/Slices/MenuSlice";
import FullPageLoader from "../Components/FullPageLoader/FullPageLoader";

const Header = () => {
  const isMobile = useWindowWidth() > 1020;
  const isSmallScreen = useWindowWidth() < 600;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const isLoggedIn = useSelector((state) => state.auth.user);
  const auth = JSON.parse(localStorage.getItem("admin"));
  const isLoading = useSelector((state) => state.allMenus.loading);
  const menus = useSelector((state) => state.allMenus.menus);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  let history = useHistory();

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const updateMenus = () => {
    console.log("menu item", menus);
    setMenuItems([...menus]);
    dispatch(toggleLoading(false));
  };

  useEffect(() => {
    updateMenus();
  }, [menus]);

  const handleLogout = () => {
    closeModal();
    dispatch(logout());
    localStorage.clear();
    history.push("/");
  };

  const showDrawer = () => {
    setVisible(true);
  };
  const redirectToAddListing = () => {
    history.push("/customer-signin");
  };

  return (
    <div>
      <LogoutModal
        closeModal={closeModal}
        showModal={showModal}
        handleLogout={handleLogout}
        isModalVisible={isModalVisible}
      />
      <Row>
        <Col lg={5} md={5} sm={5} xs={5}>
          <Link to='/'>
            <Image
              src={Logo}
              preview={false}
              width={isSmallScreen ? 180 : 220}
              alt='Bikemess'
            />
          </Link>
        </Col>
        {!isLoading && (
          <>
            {isMobile ? (
              <Col md={19} lg={19} sm={19} xs={19}>
                <div
                  style={{
                    display: "flex",
                    margin: "0rem 1rem",
                    justifyContent: "space-between",
                  }}
                >
                  <MenuItem items={menuItems} />

                  <div>
                    {isLoggedIn || auth ? (
                      <>
                        <SimpleButton
                          text='Logout'
                          loading={false}
                          size='default'
                          className={style.addListingBtn}
                          onClick={() => showModal()}
                        />
                      </>
                    ) : (
                      <SimpleButton
                        text='Login / Signup'
                        size='default'
                        loading={false}
                        className={style.addListingBtn}
                        onClick={redirectToAddListing}
                      />
                    )}
                  </div>
                </div>
              </Col>
            ) : (
              <Col
                md={19}
                lg={19}
                sm={19}
                xs={19}
                style={{ textAlign: "right", paddingRight: "40px" }}
              >
                {isLoggedIn || auth ? (
                  <LogoutOutlined
                    className={style.logoutIcon}
                    onClick={() => showModal()}
                  />
                ) : (
                  <PoweroffOutlined
                    className={style.logoutIcon}
                    onClick={redirectToAddListing}
                  />
                )}
                <UnorderedListOutlined onClick={showDrawer} />
                <Sidebar
                  visible={visible}
                  setVisible={setVisible}
                  items={menuItems}
                />
              </Col>
            )}
          </>
        )}
      </Row>
    </div>
  );
};

export default Header;
